module.exports = __webpack_public_path__ + "img/SKMJ_yield.2b2e9841.jpg";